import React, { useState, useEffect } from 'react';
import { toInteger } from 'lodash';
import numeral from 'numeral';

import EditImage from '../../utils/editImage';

import {
  Box,
  Container,
  makeStyles,
  Card,
  CardContent
} from '@material-ui/core';

import { IoMdCart } from "react-icons/io";

import Page from 'src/components/Page';
import agm from '../../services/agm'

import Alerts from '../../utils/alerts';
import Confirmations from '../../utils/confirmations';

import Results from './Results';
import Toolbar from './Toolbar';
import Product from './Product';
import Create from './Create';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const defaultItem = {
  id: null,
  codigo: null,
  nome: null,
  marca: null,
  fornecedor: null,
  unidade: null,
  codigoFornecedor: null,
  observacao: null,
  custo: null,
  valor: null,
  instalacao: null,
  ativo: 1,
  controlado: 0,
  APLICACAO: null,
  TIPO: null,
  UNIDADE: null,
  imagem: null,
  estoque: null
}

const defaultDependencies = {
  loaded: false,
  brandings: [],
  providers: [],
  units: [],
  applications: [],
  types: []
}

const defaultState = {
  loaded: false,
  records: 10,
  pages: 0,
  page: 0,
  count: 0,
  rows: []
}

const defaultStartDateTime = new Date();
const defaultEndDateTime = new Date();

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const defaultResultColumns = [
  { name: 'Código', field: 'item.codigo', size: -1, sortable: 'codigo', exportable: 1, wrap: 0 },
  { name: 'Nome', field: 'item.nome', size: -1, sortable: 'nome', exportable: 1, wrap: 0 },
  { name: 'Tipo', field: '(item.tipo) ? item.tipo.nome : "Não Informado"', size: -1, sortable: 0, exportable: 1, wrap: 0 },
  { name: 'Categoria', field: '(item.aplicacao) ? item.aplicacao.nome : "Não Informado"', size: -1, sortable: 0, exportable: 1, wrap: 0 },
  { name: 'Valor Custo', field: 'formatDecimal(item.custo, "0.00")', size: -1, sortable: 0, exportable: 1, wrap: 0 },
  { name: 'Valor Material', field: 'formatDecimal(item.valor, "0.00")', size: -1, sortable: 0, exportable: 1, wrap: 0 },
  { name: 'Valor Instalação', field: 'formatDecimal(item.instalacao, "0.00")', size: -1, sortable: 0, exportable: 1, wrap: 0 },
  { name: 'Unidade', field: '(item.unidadeProduto) ? item.unidadeProduto.nome : "???"', size: -1, sortable: 0, exportable: 1, wrap: 0 },
  { name: 'Ativo', field: '(item.ativo) ? ("Sim") : ("Não")', size: -1, sortable: 0, exportable: 1, wrap: 0 },
  { name: 'Controlar Estoque', field: 'item.controlado ? "Sim" : "Não"', size: -1, sortable: 0, exportable: 0, wrap: 0 },
];

const defaultEmptyMessage = "Nenhum Produto Foi Encontrado.";

const defaultfullMode = {
  mode: MODE_FULL,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_ENABLED,
  view: LEVEL_ACCESS_ENABLED,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultCompactMode = {
  mode: MODE_COMPACT,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_ENABLED,
  view: LEVEL_ACCESS_ENABLED,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultResultModes = [defaultfullMode, defaultCompactMode];

const defaultVisions = [
  { id: 2, name: 'Produtos pelo nome', refine: 2, label: 'Nome do Produto', history: 0 },
  { id: 1, name: 'Produtos pelo código', refine: 1, label: 'Código do Produto', history: 0 },
];

const defaultFilter = {
  pagina: 0,
  registros: 10,
  inicio: defaultStartDateTime,
  final: defaultEndDateTime,
  palavrachave: '',
  ordenacao: 'asc',
  ordem: '',
  estoques: [],
  visao: defaultVisions[0]
}

const Products = () => {

  const classes = useStyles();

  const [item, setItem] = useState(defaultItem);
  const [openCreationDialog, setOpenCreationDialog] = useState(false);
  const [openEditionDialog, setOpenEditionDialog] = useState(false);
  const [openDeletionDialog, setOpenDeletionDialog] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [message, setMessage] = useState({});
  const [filter, setFilter] = useState(defaultFilter);
  const [vision, setVision] = useState(defaultVisions[0]);
  const [resultModes, setResultModes] = useState(defaultResultModes);
  const [selectedMode, setSelectedMode] = useState(MODE_FULL);
  const [dependencies, setDependencies] = useState(defaultDependencies);
  const [openTreatmentDialog, setOpenTreatmentDialog] = useState(false);
  const [openChangeImageDialog, setOpenChangeImageDialo] = useState(false);

  const [state, setState] = useState(defaultState);

  const openExportDialog = async (format) => {
    await agm.post('/produtos/export', {
      format: format,
      filtro: filter,
      colunas: defaultResultColumns
    }, {}).then(async (response) => {
      setMessage(response.data);
      setOpenAlert(true);
      const link = window.document.createElement('a');
      var url = process.env.REACT_APP_AGM_ENDPPOINT + '/exports/produtos.xlsx';
      link.setAttribute('download', 'produtos.xlsx');
      link.href = url;
      window.document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, info: true, message: 'Erro ao gerar o arquivo. ' + error.message });
      setOpenAlert(true);
    });
  }

  const openEdition = async (item) => {
    setItem(item);
    await agm.post('/produtos/edicao', { item }, {}).then((response) => {
      if (!response.data.error) {
        setDependencies(
          {
            brandings: response.data.marcas,
            providers: response.data.fornecedores,
            units: response.data.unidades,
            applications: response.data.aplicacoes,
            types: response.data.tipos,
            lpus: response.data.lpus
          }
        );
        if (!item.id) {
          item.codigo = numeral(response.data.proximocodigo).format('0000');
        }
        setItem(item);
        setOpenEditionDialog(true);
      } else {
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, info: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const openCreation = async (item) => {
    setItem(item);
    await agm.post('/produtos/edicao', { item }, {}).then((response) => {
      if (!response.data.error) {
        setDependencies(
          {
            brandings: response.data.marcas,
            providers: response.data.fornecedores,
            units: response.data.unidades,
            applications: response.data.aplicacoes,
            types: response.data.tipos,
            lpus: response.data.lpus
          }
        );
        if (!item.id) {
          item.codigo = numeral(response.data.proximocodigo).format('0000');
        }
        setItem(item);
        setOpenCreationDialog(true);
      } else {
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, info: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const openDeletion = (item) => {
    setItem(item);
    setMessage({
      title: 'Unidades',
      message: 'Deseja excluir o produto selecionado?',
      warn: 'Esta ação irá remover este produto dos estoques em que ele foi usado.'
    });
    setOpenDeletionDialog(true);
  }

  const openTreatment = (item) => {
    setItem(item);
    setMessage({ error: true, warn: true, detail: "Função não implementada." });
    setOpenAlert(true);
  }

  const closeDeletion = () => {
    setOpenDeletionDialog(false);
  };

  const closeEdition = () => {
    setOpenEditionDialog(false);
  };

  const closeCreation = () => {
    setOpenCreationDialog(false);
  };

  const closeTreatment = () => {
    setOpenTreatmentDialog(false);
  };

  const closeAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };

  const updateTreatmentValues = (values) => {
    setItem(values);
    refreshItems();
  }

  const updateValues = (values) => {
    agm.put('/produtos/' + values.id, values).then((response) => {
      if (!response.data.error) {
        refreshItems();
        closeEdition();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
    })
  };

  const createValues = (values) => {
    agm.post('/produtos', values).then((response) => {
      if (!response.data.error) {
        refreshItems();
        closeCreation();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
    })
  };

  const deleteValues = (values) => {
    agm.delete('/produtos/' + values.id).then((response) => {
      if (!response.data.error) {
        refreshItems();
      }
      closeDeletion();
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
    })
  };

  const refreshItems = () => {
    agm.post('/produtos/pesquisar', { filtro: filter }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: toInteger((response.data.count / filter.registros)) + 1,
          page: filter.pagina,
          count: response.data.count,
          rows: response.data.rows
        });
      } else {
        setState(defaultState);
      }
    }).catch((error) => {
      console.error(error);
    })
  }

  useEffect(() => {
    if (!state.loaded) {
      refreshItems();
    }
    return
  }, []);

  const changeSort = (column, order) => {
    var value = {
      ...filter,
      ordem: column.sortable,
      ordenacao: order,
      pagina: 0,
    };
    setFilter(value);
    agm.post('/produtos/pesquisar', { filtro: value }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: toInteger((response.data.count / value.registros)) + 1,
          page: value.pagina,
          count: response.data.count,
          rows: response.data.rows
        });
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const changeFilter = (vision, keyword, page, rows, startDateTime, endDateTime, stocks) => {
    var value = {
      ...filter,
      pagina: page,
      registros: rows,
      inicio: startDateTime,
      final: endDateTime,
      palavrachave: keyword,
      estoques: stocks,
      visao: vision
    };
    setVision(vision);
    setFilter(value);
    agm.post('/produtos/pesquisar', { filtro: value }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: toInteger((response.data.count / value.registros)) + 1,
          page: value.pagina,
          count: response.data.count,
          rows: response.data.rows
        });
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const updateDependencies = async (values) => {
    var uf = (values.uf) ? values.uf : null;
    var empresa = (values.empresa) ? values.empresa : null;
    await agm.get('/unidades/edicao/' + uf + "," + empresa, {}, {}).then((response) => {
      if (!response.data.error) {
        setDependencies(
          {
            brandings: response.data.marcas,
            providers: response.data.fornecedores,
            units: response.data.unidades,
            applications: response.data.aplicacoes,
            types: response.data.tipos,
            lpus: response.data.lpus
          }
        );
        setItem(values);
      } else {
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, info: true, message: error.message });
      setOpenAlert(true);
    })
  };

  const clearImage = (item) => {
    item.imagem = null;
    agm.put('/produtos/' + item.id, item).then((response) => {
      if (!response.data.error) {
        refreshItems();
        openEdition(item)
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
    })
  };


  const openChangeImage = (item) => {
    item.imagem = null;
    setOpenChangeImageDialo(true);
  }

  const closeChangeImageDialog = () => {
    setOpenChangeImageDialo(false);
  }

  const saveImage = (item, file) => {
    const data = new FormData();
    data.append('product', item.id);
    data.append('file', file);
    agm.post('/produtos/imagem', data, { product: item.id }, {
      onUploadProgress: e => {
        console.error((e.loaded * 100) / e.total);
      }
    }).then((response) => {
      if (!response.data.error) {
        item.imagem = item.id + '.png';
        closeChangeImageDialog();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: "Erro ao alterar Imagem do Produto. ", detail: error.message });
      setOpenAlert(true);
    });
  }

  return (
    <Page
      className={classes.root}
      title="Produtos"
    >
      <Container maxWidth={false}>

        <Toolbar
          icon={IoMdCart}
          item={defaultItem}
          resultset={state}
          resultModes={resultModes}
          vision={vision}
          visions={defaultVisions}
          selectedMode={selectedMode}
          openCreation={openCreation}
          changeFilter={changeFilter}
        />

        <Alerts message={message}
          open={openAlert}
          closeAlert={closeAlert} />

        <Confirmations item={item}
          message={message}
          open={openDeletionDialog}
          close={closeDeletion}
          confirmation={deleteValues} />

        <Confirmations item={item}
          message={message}
          open={openTreatmentDialog}
          close={closeTreatment}
          confirmation={updateTreatmentValues} />

        <Product item={item}
          open={openEditionDialog}
          closeEdition={closeEdition}
          updateValues={updateValues}
          dependencies={dependencies}
          updateDependencies={updateDependencies}
          clearImage={clearImage}
          openChangeImage={openChangeImage}
        />

        <Create item={item}
          open={openCreationDialog}
          closeCreation={closeCreation}
          createValues={createValues}
          dependencies={dependencies}
          updateDependencies={updateDependencies}
        />

        <EditImage
          item={item}
          open={openChangeImageDialog}
          close={closeChangeImageDialog}
          save={saveImage}
        />

        <Box mt={3}>
          <Card>
            <CardContent>
              <Results
                resultSet={state}
                resultModes={resultModes}
                icon={IoMdCart}
                vision={vision}
                selectedMode={selectedMode}
                openEdition={openEdition}
                openDeletion={openDeletion}
                openTreatment={openTreatment}
                openExportDialog={openExportDialog}
                changeSort={changeSort}
              />
            </CardContent>
          </Card>
        </Box>
      </Container>
    </Page >
  );
};

export default Products;
